import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLine = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.8 15.5269L9.4 9.92692L12.65 13.1769C12.8667 13.3769 13.1208 13.4728 13.4125 13.4644C13.7042 13.4561 13.9417 13.3436 14.125 13.1269L21.625 4.65192C21.7917 4.45192 21.8708 4.21859 21.8625 3.95192C21.8542 3.68526 21.7583 3.46026 21.575 3.27692C21.3583 3.07692 21.1125 2.98526 20.8375 3.00192C20.5625 3.01859 20.3417 3.12692 20.175 3.32692L13.375 10.9519L10.1 7.62692C9.9 7.42692 9.66667 7.32692 9.4 7.32692C9.13333 7.32692 8.9 7.42692 8.7 7.62692L2.3 14.0269C2.1 14.2436 2 14.4978 2 14.7894C2 15.0811 2.1 15.3269 2.3 15.5269C2.5 15.7436 2.75 15.8519 3.05 15.8519C3.35 15.8519 3.6 15.7436 3.8 15.5269ZM22.55 19.2403C22.75 19.3558 22.75 19.6444 22.55 19.7599L19.7 21.4054C19.5 21.5208 19.25 21.3765 19.25 21.1455V20.0001H2V19.0001H19.25V17.8546C19.25 17.6237 19.5 17.4794 19.7 17.5948L22.55 19.2403Z"
	})
});
export default SvgChartLine;
